import './app.css';
import App from './App.svelte';
import { mount } from 'svelte';

const link = document.createElement('link');
link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap';
link.rel = 'stylesheet';
document.head.appendChild(link);

const app = mount(App, {
    target: document.getElementById('app')!,
});

export default app;
